/* eslint-disable react/prop-types */
import { Button } from "@/components/ui/button";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from "../../components/ui/drawer";
import { toast } from "sonner";
import Spinner from "../Spinner";
import CurrencyInput from "react-currency-input-field";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { PostRequest } from "@/lib/http";
import { Loading } from "notiflix";

const PaymentInfo = ({ onClose, initialAmount }) => {
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      amount: initialAmount,
      name: "",
      bank_name: "",
      acct_name: "",
      acct_number: "",
      ref: "",
    },
  });
  const navigate = useNavigate();

  async function onSubmit(formData) {
    Loading.standard("Sending Request");
    const { err } = await PostRequest({
      url: "/api/depositRequest",
      body: {
        account_name: formData.name,
        amount: formData.amount.replace(/,/g, "").replace("₦", ""),
        bank: formData.bank_name,
        account_number: formData.bank_name,
        reference: formData.ref,
      },
    });
    if (!err) {
      navigate("/");
      toast.success("Deposit Request sent successfully", {
        duration: 5000,
      });
    } else {
      toast.error(err);
    }
    Loading.remove();
  }

  return (
    <Drawer open={true} onOpenChange={onClose}>
      <DrawerContent className="font-jakarta">
        <div className="mx-auto w-full max-w-sm">
          <DrawerHeader>
            <DrawerTitle>Payment Information</DrawerTitle>
            <DrawerDescription>
              Please fill all necessary information
            </DrawerDescription>
          </DrawerHeader>
          <div className="p-4 pb-0">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="grid grid-cols-1 gap-[15px]">
                {/* Depositor's Name */}
                <div className="col-span-1">
                  <label
                    htmlFor="name"
                    className="dark:text-darkGray text-sm font-medium"
                  >
                    Depositor's Name
                  </label>

                  <input
                    {...register("name", {
                      required: "Depositor's name is required",
                    })}
                    type="text"
                    className="dark:border-darkBorder dark:bg-darkInput w-full rounded-md border bg-gray-100 px-2 py-3 text-sm text-black outline-none dark:text-white"
                    placeholder="Enter name on the account"
                  />
                  {errors.name && (
                    <span className="text-xs font-medium text-red-500">
                      {errors.name.message}
                    </span>
                  )}
                </div>

                {/* Bank Name */}
                <div className="col-span-1">
                  <label
                    htmlFor="bank_name"
                    className="dark:text-darkGray text-sm font-medium"
                  >
                    Name of the Bank Paid from
                  </label>

                  <input
                    {...register("bank_name", {
                      required: "Bank name is required",
                    })}
                    type="text"
                    className="dark:border-darkBorder dark:bg-darkInput w-full rounded-md border bg-gray-100 px-2 py-3 text-sm text-black outline-none dark:text-white"
                    placeholder="Enter name of Bank"
                  />
                  {errors.bank_name && (
                    <span className="text-xs font-medium text-red-500">
                      {errors.bank_name.message}
                    </span>
                  )}
                </div>

                {/* Amount Paid */}
                <div className="col-span-1">
                  <label
                    htmlFor="amount"
                    className="dark:text-darkGray text-sm font-medium"
                  >
                    Amount Paid (₦)
                  </label>

                  <CurrencyInput
                    value={initialAmount}
                    type="text"
                    className="dark:border-darkBorder dark:bg-darkInput w-full rounded-md border bg-gray-100 px-2 py-3 text-sm text-black outline-none dark:text-white"
                    placeholder="Enter amount paid"
                    prefix="₦ "
                    {...register("amount", {
                      required: "Amount is required",
                    })}
                  />
                  {errors.amount && (
                    <span className="text-xs font-medium text-red-500">
                      {errors.amount.message}
                    </span>
                  )}
                </div>

                {/* Teller/Ref Number */}
                <div className="col-span-1">
                  <label
                    htmlFor="ref"
                    className="dark:text-darkGray text-sm font-medium"
                  >
                    Teller/Reference Number
                  </label>

                  <input
                    {...register("ref", {
                      required: "Reference number is required",
                    })}
                    type="text"
                    className="bg dark:border-darkBorder dark:bg-darkInput w-full rounded-md border bg-gray-100 px-2 py-3 text-sm text-black outline-none dark:text-white"
                    placeholder="Enter transition id / reference number"
                  />
                  {errors.ref && (
                    <span className="text-xs font-medium text-red-500">
                      {errors.ref.message}
                    </span>
                  )}
                </div>
              </div>
            </form>
          </div>
          <DrawerFooter>
            <Button
              className="bg-primary btn font-medium text-white disabled:opacity-70"
              disabled={loading}
              onClick={handleSubmit(onSubmit)}
            >
              {!loading ? "Submit" : <Spinner />}
            </Button>
            <DrawerClose asChild>
              <Button className="border border-gray-200 bg-transparent text-black hover:bg-gray-100 hover:text-black dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white">
                Close
              </Button>
            </DrawerClose>
          </DrawerFooter>
        </div>
      </DrawerContent>
    </Drawer>
  );
};

export default PaymentInfo;
